import { AnimatePresence, motion} from 'framer-motion'

// css
import './css/slidecomponent.css'
import './css/slide5.css'

//images
import PngMe from '../images/static/pngme.png'

const Slide_5 = ({ counter }) => { 
	return(
		<AnimatePresence>
			{counter === 5 &&
			<motion.div 
				key="slide_components_1key0"
				initial={{opacity:0}}
				animate={{opacity:1}}
				transition={{duration:1}}
				exit={{opacity:0}}
				className="slide_components" id="slide_components_5" 
				>
					<AnimatePresence>
					<motion.p initial={{opacity:0}} animate={{opacity:1}} transition={{duration:1,delay:1}} exit={{opacity:0}} className="hireme_title">Hire me</motion.p>
					</AnimatePresence>

					<AnimatePresence>
					<motion.div initial={{opacity:0}} animate={{opacity:1}}  transition={{duration:1,delay:1.5}} exit={{opacity:0}} className="hireme_card">
						<div className="hireme_card_img_container">
							<img src={PngMe} alt="" />
						</div>	

						<div className="hireme_card_content">
							<i className="fas fa-handshake"></i>
							<div className="business">
								<p>open for business</p>
							</div>
							<div>
								<b>A. Yassine</b>
								<p className="job">MERN stack web developer</p>							
							</div>
						</div>
					</motion.div>
					</AnimatePresence>

					<AnimatePresence>
					<div className="hireme_links">
						<motion.a initial={{opacity:0,y:40}} animate={{opacity:1,y:0}} transition={{duration:.5,delay:1.8}} exit={{opacity:0}}  href="/"><i className="fab fa-linkedin"></i></motion.a>
						<motion.a initial={{opacity:0,y:40}} animate={{opacity:1,y:0}} transition={{duration:.5,delay:2.1}} exit={{opacity:0}}  href="/"><i className="fab fa-twitter"></i></motion.a>
						<motion.a initial={{opacity:0,y:40}} animate={{opacity:1,y:0}} transition={{duration:.5,delay:2.3}} exit={{opacity:0}}  href="/"><i className="fab fa-github"></i></motion.a>
						<motion.a initial={{opacity:0,y:40}} animate={{opacity:1,y:0}} transition={{duration:.5,delay:2.5}} exit={{opacity:0}}  href="/"><i className="fab fa-instagram"></i></motion.a>
						<motion.a initial={{opacity:0,y:40}} animate={{opacity:1,y:0}} transition={{duration:.5,delay:2.7}} exit={{opacity:0}}  href="/"><i className="fab fa-facebook"></i></motion.a>
					</div>
					</AnimatePresence>
			</motion.div>
			}
		</AnimatePresence>
		)
}

export default Slide_5